import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e3ebfe4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h1 text-danger" }, " You first need to log into your account. ", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "row fw-bold"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold h3" }, " Please upload following Documents ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, " (Note: only JPG, JPEG, PNG & GIF files are allowed with maximum size of 3MB) ", -1))
const _hoisted_7 = {
  class: "camera-section",
  style: {"margin":"20px 0","padding":"15px","border":"2px solid #007bff","border-radius":"10px","background-color":"#f8f9fa"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold h4 mb-3" }, "Face Capture for Verification", -1))
const _hoisted_9 = { style: {"display":"inline-block","margin-right":"20px","position":"relative"} }
const _hoisted_10 = {
  ref: "videoRef",
  autoplay: "",
  muted: "",
  width: "320",
  height: "240",
  style: {"border":"2px solid #ccc","background-color":"#000","border-radius":"8px"}
}
const _hoisted_11 = {
  ref: "canvasRef",
  style: {"position":"absolute","top":"0","left":"0","display":"none"}
}
const _hoisted_12 = { style: {"margin-top":"10px"} }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { style: {"margin-top":"10px"} }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-success mt-2" }, "✅ Face Features Saved Successfully!", -1))
const _hoisted_19 = { class: "text-left container border-1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-1 bg-primary" }, [
    /*#__PURE__*/_createElementVNode("td", { class: "border-1 col-3 text-center" }, "Name"),
    /*#__PURE__*/_createElementVNode("td", { class: "border-1 col-2 text-center" }, "Uploaded"),
    /*#__PURE__*/_createElementVNode("td", { class: "border-1 col-7 text-center" }, "Action")
  ])
], -1))
const _hoisted_21 = { class: "border-1" }
const _hoisted_22 = { class: "border-1" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-1" }, "    Passport", -1))
const _hoisted_24 = { class: "border-1 text-center" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_28 = { class: "border-1" }
const _hoisted_29 = {
  enctype: "multipart/form-data",
  method: "post",
  id: 'PassportForm'
}
const _hoisted_30 = { class: "border-1" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "ml-4 border-1" }, "    Passport Size Photograph", -1))
const _hoisted_32 = { class: "border-1 text-center" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_36 = { class: "border-1" }
const _hoisted_37 = {
  enctype: "multipart/form-data",
  method: "post",
  id: 'PhotoForm'
}
const _hoisted_38 = { class: "border-1" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-1" }, "    Visa Share Code", -1))
const _hoisted_40 = { class: "border-1 text-center" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = ["src"]
const _hoisted_43 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_44 = { class: "border-1" }
const _hoisted_45 = {
  enctype: "multipart/form-data",
  method: "post",
  id: 'VisaForm'
}
const _hoisted_46 = { class: "border-1" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-1" }, "    SIA Licence", -1))
const _hoisted_48 = { class: "border-1 text-center" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = ["src"]
const _hoisted_51 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_52 = { class: "border-1" }
const _hoisted_53 = {
  enctype: "multipart/form-data",
  method: "post",
  id: 'SIABadgeForm'
}
const _hoisted_54 = { class: "border-1" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-1" }, "    National Insurance Number/UTR", -1))
const _hoisted_56 = { class: "border-1 text-center" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = ["src"]
const _hoisted_59 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_60 = { class: "border-1" }
const _hoisted_61 = {
  enctype: "multipart/form-data",
  method: "post",
  id: 'NINoDocForm'
}
const _hoisted_62 = { class: "border-1" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-1" }, "    DrivingLicence", -1))
const _hoisted_64 = { class: "border-1 text-center" }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = ["src"]
const _hoisted_67 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_68 = { class: "border-1" }
const _hoisted_69 = {
  enctype: "multipart/form-data",
  method: "post",
  id: 'DrivingLicenceForm'
}
const _hoisted_70 = { class: "border-1" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-1" }, "    Proof of Address 01", -1))
const _hoisted_72 = { class: "border-1 text-center" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = ["src"]
const _hoisted_75 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_76 = { class: "border-1" }
const _hoisted_77 = {
  enctype: "multipart/form-data",
  method: "post",
  id: 'AddressDocForm'
}
const _hoisted_78 = { class: "ml-4 p-2 border-1" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-1" }, "    Proof of Address 02", -1))
const _hoisted_80 = { class: "border-1 text-center" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = ["src"]
const _hoisted_83 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_84 = { class: "border-1" }
const _hoisted_85 = {
  enctype: "multipart/form-data",
  method: "post",
  id: 'AdditionalDoc1Form'
}
const _hoisted_86 = { class: "border-1" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-1" }, "    Supporting Document", -1))
const _hoisted_88 = { class: "border-1 text-center" }
const _hoisted_89 = { key: 0 }
const _hoisted_90 = ["src"]
const _hoisted_91 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_92 = { class: "border-1" }
const _hoisted_93 = {
  enctype: "multipart/form-data",
  method: "post",
  id: 'AdditionalDoc2Form'
}
const _hoisted_94 = { class: "border-1" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-1" }, "    Supporting Document", -1))
const _hoisted_96 = { class: "border-1 text-center" }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = ["src"]
const _hoisted_99 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_100 = { class: "border-1" }
const _hoisted_101 = {
  enctype: "multipart/form-data",
  method: "post",
  id: 'AdditionalDoc3Form'
}
const _hoisted_102 = { class: "border-1" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-1" }, "    All Documents PDF", -1))
const _hoisted_104 = { class: "border-1 text-center" }
const _hoisted_105 = { key: 0 }
const _hoisted_106 = ["src"]
const _hoisted_107 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_108 = { class: "border-1" }
const _hoisted_109 = {
  enctype: "multipart/form-data",
  method: "post",
  id: 'documentsForm'
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (!$setup.loggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    ($setup.loggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("video", _hoisted_10, null, 512),
              _createElementVNode("canvas", _hoisted_11, null, 512)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.startCamera && $setup.startCamera(...args))),
                disabled: $setup.cameraStarted,
                class: "btn btn-primary btn-sm"
              }, " Start Camera ", 8, _hoisted_13),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.captureAndSaveFaceFeatures && $setup.captureAndSaveFaceFeatures(...args))),
                disabled: !$setup.cameraStarted || $setup.isProcessing,
                class: "btn btn-success btn-sm"
              }, _toDisplayString($setup.isProcessing ? 'Processing...' : 'Take Photo & Save'), 9, _hoisted_14),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.stopCamera && $setup.stopCamera(...args))),
                disabled: !$setup.cameraStarted,
                class: "btn btn-danger btn-sm"
              }, " Stop Camera ", 8, _hoisted_15)
            ]),
            _createElementVNode("div", _hoisted_16, [
              ($setup.faceStatusMessage)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass($setup.faceStatusClass),
                    style: {"padding":"8px","border-radius":"4px","margin-top":"10px"}
                  }, _toDisplayString($setup.faceStatusMessage), 3))
                : _createCommentVNode("", true),
              ($setup.savedFeatures)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("small", null, "Feature vector length: " + _toDisplayString($setup.savedFeatures.length) + " numbers", 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("table", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("tbody", _hoisted_21, [
              _createElementVNode("tr", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("td", _hoisted_24, [
                  ($setup.getIconUrl('Passport'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("img", {
                          src: $setup.getIconUrl('Passport'),
                          style: {"width":"40px","height":"40px","object-fit":"contain","border-radius":"4px","cursor":"pointer"},
                          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.downloadDocument('Passport'))),
                          title: "Click to download"
                        }, null, 8, _hoisted_26)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_27, "NO"))
                ]),
                _createElementVNode("td", _hoisted_28, [
                  _createElementVNode("form", _hoisted_29, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.chooseDocument('Passport')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("td", _hoisted_32, [
                  ($setup.getIconUrl('Photo'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("img", {
                          src: $setup.getIconUrl('Photo'),
                          style: {"width":"40px","height":"40px","object-fit":"contain","border-radius":"4px","cursor":"pointer"},
                          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.downloadDocument('Photo'))),
                          title: "Click to download"
                        }, null, 8, _hoisted_34)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_35, "NO"))
                ]),
                _createElementVNode("td", _hoisted_36, [
                  _createElementVNode("form", _hoisted_37, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[6] || (_cache[6] = ($event: any) => ($setup.chooseDocument('Photo')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("td", _hoisted_40, [
                  ($setup.getIconUrl('Visa'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("img", {
                          src: $setup.getIconUrl('Visa'),
                          style: {"width":"40px","height":"40px","object-fit":"contain","border-radius":"4px","cursor":"pointer"},
                          onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.downloadDocument('Visa'))),
                          title: "Click to download"
                        }, null, 8, _hoisted_42)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_43, "NO"))
                ]),
                _createElementVNode("td", _hoisted_44, [
                  _createElementVNode("form", _hoisted_45, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[8] || (_cache[8] = ($event: any) => ($setup.chooseDocument('Visa')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("td", _hoisted_48, [
                  ($setup.getIconUrl('SIABadge'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _createElementVNode("img", {
                          src: $setup.getIconUrl('SIABadge'),
                          style: {"width":"40px","height":"40px","object-fit":"contain","border-radius":"4px","cursor":"pointer"},
                          onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.downloadDocument('SIABadge'))),
                          title: "Click to download"
                        }, null, 8, _hoisted_50)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_51, "NO"))
                ]),
                _createElementVNode("td", _hoisted_52, [
                  _createElementVNode("form", _hoisted_53, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[10] || (_cache[10] = ($event: any) => ($setup.chooseDocument('SIABadge')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_54, [
                _hoisted_55,
                _createElementVNode("td", _hoisted_56, [
                  ($setup.getIconUrl('NINoDoc'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createElementVNode("img", {
                          src: $setup.getIconUrl('NINoDoc'),
                          style: {"width":"40px","height":"40px","object-fit":"contain","border-radius":"4px","cursor":"pointer"},
                          onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.downloadDocument('NINoDoc'))),
                          title: "Click to download"
                        }, null, 8, _hoisted_58)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_59, "NO"))
                ]),
                _createElementVNode("td", _hoisted_60, [
                  _createElementVNode("form", _hoisted_61, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[12] || (_cache[12] = ($event: any) => ($setup.chooseDocument('NINoDoc')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("td", _hoisted_64, [
                  ($setup.getIconUrl('DrivingLicence'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        _createElementVNode("img", {
                          src: $setup.getIconUrl('DrivingLicence'),
                          style: {"width":"40px","height":"40px","object-fit":"contain","border-radius":"4px","cursor":"pointer"},
                          onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.downloadDocument('DrivingLicence'))),
                          title: "Click to download"
                        }, null, 8, _hoisted_66)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_67, "NO"))
                ]),
                _createElementVNode("td", _hoisted_68, [
                  _createElementVNode("form", _hoisted_69, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[14] || (_cache[14] = ($event: any) => ($setup.chooseDocument('DrivingLicence')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_70, [
                _hoisted_71,
                _createElementVNode("td", _hoisted_72, [
                  ($setup.getIconUrl('AddressDoc'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                        _createElementVNode("img", {
                          src: $setup.getIconUrl('AddressDoc'),
                          style: {"width":"40px","height":"40px","object-fit":"contain","border-radius":"4px","cursor":"pointer"},
                          onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.downloadDocument('AddressDoc'))),
                          title: "Click to download"
                        }, null, 8, _hoisted_74)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_75, "NO"))
                ]),
                _createElementVNode("td", _hoisted_76, [
                  _createElementVNode("form", _hoisted_77, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[16] || (_cache[16] = ($event: any) => ($setup.chooseDocument('AddressDoc')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_78, [
                _hoisted_79,
                _createElementVNode("td", _hoisted_80, [
                  ($setup.getIconUrl('AdditionalDoc1'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                        _createElementVNode("img", {
                          src: $setup.getIconUrl('AdditionalDoc1'),
                          style: {"width":"40px","height":"40px","object-fit":"contain","border-radius":"4px","cursor":"pointer"},
                          onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.downloadDocument('AdditionalDoc1'))),
                          title: "Click to download"
                        }, null, 8, _hoisted_82)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_83, "NO"))
                ]),
                _createElementVNode("td", _hoisted_84, [
                  _createElementVNode("form", _hoisted_85, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[18] || (_cache[18] = ($event: any) => ($setup.chooseDocument('AdditionalDoc1')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_86, [
                _hoisted_87,
                _createElementVNode("td", _hoisted_88, [
                  ($setup.getIconUrl('AdditionalDoc2'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                        _createElementVNode("img", {
                          src: $setup.getIconUrl('AdditionalDoc2'),
                          style: {"width":"40px","height":"40px","object-fit":"contain","border-radius":"4px","cursor":"pointer"},
                          onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.downloadDocument('AdditionalDoc2'))),
                          title: "Click to download"
                        }, null, 8, _hoisted_90)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_91, "NO"))
                ]),
                _createElementVNode("td", _hoisted_92, [
                  _createElementVNode("form", _hoisted_93, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[20] || (_cache[20] = ($event: any) => ($setup.chooseDocument('AdditionalDoc2')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_94, [
                _hoisted_95,
                _createElementVNode("td", _hoisted_96, [
                  ($setup.getIconUrl('AdditionalDoc3'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                        _createElementVNode("img", {
                          src: $setup.getIconUrl('AdditionalDoc3'),
                          style: {"width":"40px","height":"40px","object-fit":"contain","border-radius":"4px","cursor":"pointer"},
                          onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.downloadDocument('AdditionalDoc3'))),
                          title: "Click to download"
                        }, null, 8, _hoisted_98)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_99, "NO"))
                ]),
                _createElementVNode("td", _hoisted_100, [
                  _createElementVNode("form", _hoisted_101, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      name: "profile_pic",
                      onChange: _cache[22] || (_cache[22] = ($event: any) => ($setup.chooseDocument('AdditionalDoc3')))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_102, [
                _hoisted_103,
                _createElementVNode("td", _hoisted_104, [
                  ($setup.getIconUrl('documents'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                        _createElementVNode("img", {
                          src: $setup.getIconUrl('documents'),
                          style: {"width":"40px","height":"40px","object-fit":"contain","border-radius":"4px","cursor":"pointer"},
                          onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.downloadDocument('documents'))),
                          title: "Click to download PDF"
                        }, null, 8, _hoisted_106)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_107, "NO"))
                ]),
                _createElementVNode("td", _hoisted_108, [
                  _createElementVNode("form", _hoisted_109, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: ".pdf",
                      name: "profile_pic",
                      onChange: _cache[24] || (_cache[24] = ($event: any) => ($setup.chooseDocumentPDF('documents')))
                    }, null, 32)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}